module.exports = __webpack_public_path__ + "img/ecoIcon.6b89db40.png";